import { PurchasesUrlQueryParams } from "../APICalls/buildGetPurchasesUrl";
import { AppliedCheckbox } from "../Hooks/useAppliedCheckBoxes";
import User from "../Interfaces/User";
import getMakeModelTransportAnalytics from "./getMakeModelTransportAnalytics";

const pageViewDataPush = (
  purchasesUrlQueryParams: PurchasesUrlQueryParams,
  user: User,
  initialLoad = false,
  res: any = { results: [], totalPages: 0 },
  appliedCheckboxes: AppliedCheckbox[] = []
) => {
  const makeModelTransportAnalytics =
    getMakeModelTransportAnalytics(appliedCheckboxes);
  let markedForExportCount = 0;
  res.results.forEach((vehicle) => {
    if (vehicle.delivery.isExport === true) {
      markedForExportCount += 1;
    }
  });
  //@ts-ignore
  if (window.digitalData) {
    let result: any = {
      event: {
        name: "search-pageview",
      },
      search: {
        pagination: `${purchasesUrlQueryParams.page}|${res.totalPages}`,
        sortBy: purchasesUrlQueryParams.sort,
        dateFilter: purchasesUrlQueryParams.numberofDays,
        keyword: purchasesUrlQueryParams.q,
        ...makeModelTransportAnalytics,
      },
      transport: {
        vrmReturned: `${res.results.length}|${
          res.results.length - markedForExportCount
        }|${markedForExportCount}`,
      },
    };
    if (initialLoad) {
      result.user = {
        userType: "",
        aaId: user?.peep_analyticsid, //customerAccountUserID|peep_analyticsID
        ssoId: user?.ssoId, //SSOID|sub
        cas: user?.casId, //sourceaccount_Id
        authenticated: "is-logged-in",
      };
      result.journey = {
        name: "purchases",
      };
    }
    //@ts-ignore
    digitalData.push(result);
  }
};

export default pageViewDataPush;
